import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem } from '@mui/material';
import { CustomSelectField, SelectInputProps, InputLabelProps } from './componentsnew';

const InputSelectField = ({
  label,
  value,
  onChange,
  options = [],
  variant = 'standard',
  error = false,
  disabled = false,
  fullWidth = true,
  renderValue,
  placeholder = 'Select',
  children,
  sx,
  helperText,
  inputProps,
  id,
  ...props
}) => {
  const inputId = id || (label ? label.toLowerCase().replace(/[^a-z0-9]+/g, '-') : 'custom-select');

  const optionList = Array.isArray(options) ? options : [];
  const hasValue = value !== undefined && value !== null && value !== '';
  const valueInOptions = optionList.some((opt) => (typeof opt === 'object' ? opt?.value === value : opt === value));
  const menuItems = [
    ...(hasValue && !valueInOptions ? [<MenuItem key={`__current-${value}`} value={value}>{value}</MenuItem>] : []),
    ...optionList.map((opt, idx) => {
      const optVal = typeof opt === 'object' ? (opt?.value !== undefined ? opt.value : '') : opt;
      const optLabel = typeof opt === 'object' ? (opt?.label !== undefined ? opt.label : opt?.value) : opt;
      return (
        <MenuItem key={`${optVal}-${idx}`} value={optVal}>
          {optLabel}
        </MenuItem>
      );
    }),
  ];

  return (
    <FormControl
      fullWidth={fullWidth}
      variant={variant}
      size='small'
      error={error}
      disabled={disabled}
      sx={sx}
      {...props}
    >
      {label && <InputLabel id={`${inputId}-label`} {...InputLabelProps}>{label}</InputLabel>}
      <CustomSelectField
        {...SelectInputProps}
        label={label}
        labelId={label ? `${inputId}-label` : undefined}
        id={inputId}
        inputProps={inputProps}
        value={value ?? ''}
        onChange={(event, child) => {
          if (onChange) {
            onChange(event, child);
          }
        }}
        displayEmpty
        variant={variant}
        disabled={disabled}
        error={error}
        renderValue={renderValue || ((selected) => {
          if (selected === '' || selected == null) return placeholder;
          const match = Array.isArray(options) ? options.find((opt) => (typeof opt === 'object' ? opt?.value === selected : opt === selected)) : null;
          if (match && typeof match === 'object' && match.label) {
            return match.label;
          }
          return selected;
        })}
      >
        {children || menuItems}
      </CustomSelectField>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default InputSelectField;
